module.exports = __webpack_public_path__ + "static/media/carte_guinee.a3c1bcf6.svg";